import {
  CalculatorOperations,
  getIngredientsBySpongeCakeType,
  rectangleSpongeCakeField
} from '../../../../helpers/cake'
import { rectangleSpongeCakeValidator } from './RectangleCakeValidator'

interface RectangleSpongeCakeCalculatorActions {
  l: string
  w: string
  errors: string[]
  chosenSpongeType: string
  ingredients: string[]
  result: number | null
  calculate: () => void
}

export const initialRectangleSpongeCakeReducer: RectangleSpongeCakeCalculatorActions =
  {
    l: '',
    w: '',
    errors: [],
    chosenSpongeType: '',
    ingredients: [],
    result: null,
    calculate: (): void => {
      // Initial method
    }
  }

const updateValidationErrors = (
  errors: string[],
  state: RectangleSpongeCakeCalculatorActions
): RectangleSpongeCakeCalculatorActions => ({
  ...state,
  errors,
  ingredients: [],
  result: null
})

const calculateResult = (
  state: RectangleSpongeCakeCalculatorActions
): RectangleSpongeCakeCalculatorActions => {
  const result = Math.round(
    rectangleSpongeCakeField(parseFloat(state.l), parseFloat(state.w))
  )
  return {
    ...state,
    result,
    ingredients: getIngredientsBySpongeCakeType(state.chosenSpongeType, result),
    errors: []
  }
}

export enum RectangleSpongeCakeReducerActionName {
  CALCULATE_RESULT = 'CALCULATE_RESULT',
  UPDATE_RECTANGLE_SPONGE_CAKE_CALC_DATA = 'UPDATE_RECTANGLE_SPONGE_CAKE_CALC_DATA'
}

export type RectangleSpongeCakeReducerActions =
  | {
      type: RectangleSpongeCakeReducerActionName.CALCULATE_RESULT
    }
  | {
      type: RectangleSpongeCakeReducerActionName.UPDATE_RECTANGLE_SPONGE_CAKE_CALC_DATA
      data: CalculatorOperations
    }

const calculate = (
  state: RectangleSpongeCakeCalculatorActions
): RectangleSpongeCakeCalculatorActions => {
  const validationErrors = rectangleSpongeCakeValidator(state.l, state.w)
  if (validationErrors.length > 0) {
    return updateValidationErrors(validationErrors, state)
  }
  return calculateResult(state)
}

const updateCalcData = (
  data: CalculatorOperations,
  state: RectangleSpongeCakeCalculatorActions
): RectangleSpongeCakeCalculatorActions => ({
  ...state,
  [data.fieldName]: data.fieldValue
})

export const rectangleSpongeCakeReducer = (
  state: RectangleSpongeCakeCalculatorActions,
  action: RectangleSpongeCakeReducerActions
): RectangleSpongeCakeCalculatorActions => {
  switch (action.type) {
    case RectangleSpongeCakeReducerActionName.CALCULATE_RESULT:
      return calculate(state)
    case RectangleSpongeCakeReducerActionName.UPDATE_RECTANGLE_SPONGE_CAKE_CALC_DATA:
      return updateCalcData(action.data, state)
    default:
      return state
  }
}
